import { Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import TaskDetailAndStatus from '../components/TaskDetailAndStatus';
import { ConfigStore } from '../stores/ConfigStore';

interface SummaryProps {
    configStore: ConfigStore;
    newTaskId?: string;
}

const Summary = observer((props: SummaryProps) => {
    const task = props.newTaskId ? { rowid: props.newTaskId } : { rowid: props.configStore.task_id };

    return (
        <Stack direction="column" className="Summary">
            {task ? <TaskDetailAndStatus configStore={props.configStore} task={task} /> : null}
        </Stack>
    );
});

export default Summary;
